import React from 'react'
import { Image } from '@/components/atoms/Image/Image'
import { HostProps } from './types'

export function Host({ avatar, title, name }: HostProps) {
  return (
    <div className="flex items-center">
      <div className="w-64 h-64 !object-cover overflow-hidden">
        <Image
          fluid
          fixed={false}
          data={avatar}
          options={{ width: 64 }}
          className="!w-full !object-cover !h-full"
          imgClassName="rounded-full"
        />
      </div>
      <div className="ml-16 font-poppins text-bodyL tracking-sm text-text-dark-900">
        <p>{title}</p>
        <p className="font-bold">{name}</p>
      </div>
    </div>
  )
}
